<template>
	<div class="close-shoptime-body">
		<div class="fx-header">
			<p>营业时间</p>
		</div>
		<div class="close-shoptime-container">
			<div class="setting-change">
				<div>
					<div class="label">是否启用营业：</div>
					<el-switch v-model="closeShopflag" size="small" class="set-flag-switch" @change="handleChangeSetting(closeShopflag)" :active-value="false" :inactive-value="true" active-text="开" inactive-text="关"/>
				</div>
				<div class="tips">
					<span v-show="closeShopflag">关闭时，用户可在任意时间下单。</span>
					<span v-show="!closeShopflag">开启后，营业时间内用户可以下单。</span>
				</div>
			</div>
		</div>
		<div class="setting-detail" v-if="!closeShopflag">
			<div class='row-box'>
				<div class="label">非营业日期：</div>
				<el-date-picker
					size="mini"
					format='yyyy-MM-dd'
					value-format='yyyy-MM-dd'
					type="dates"
					v-model="unOpenDate"
					placeholder="选择一个或多个日期">
				</el-date-picker>
				<div class="tips">
					<span>设置非营业日期后，非营业日期不允许用户下单，未设置非营业日期时，默认当前店铺按所有正常营业日期范围营业</span>
				</div>
			</div>
			<div class="detail-box">
				<div class="label">营业时间段：</div>
				<div class="all-time-box">
					<div v-for="(item, index) in timeList" :key="index" class="time-item">
						<el-time-select
							v-model="item.startDate"
							class="date-box"
							format="HH:mm"
							value-format="HH:mm"
							size="mini"
							:picker-options="{
								selectableRange: `00:00:00 -${item.endDate ? item.endDate + ':00' : '24:00:00'}`,
								step: '00:15',
								start: '00:00',
								end: !item.endDate ? '24:00' : item.endDate
							}"
							placeholder="请选择"
							@change="changeStartTime(item, index)"
						></el-time-select> ~
						<el-time-select
							v-model="item.endDate"
							class="date-box"
							format="HH:mm"
							value-format="HH:mm"
							size="mini"
							:picker-options="{
								selectableRange: `${item.startDate ? item.startDate + ':00' : '00:00:00'}-24:00:00`,
								step: '00:15',
								start: item.startDate,
								end: '24:00'
							}"
							placeholder="请选择"
							@change="changeEndTime(item, index)"
						></el-time-select>
						<i class="el-icon-remove-outline delete" v-if="item.isShow" @click="deleteItem(item, index)"></i> <span style="color:#F56C6C;margin-left: 20px;" v-if="item.errorFlag || item.errorFlag2">时间段不能交叉</span>
					</div>
				</div>
			</div>
			<div class="add" @click="addItem">+ 添加</div>
		</div>
		<div class="button-box" v-if="!closeShopflag && AuthorityList['01_0001_0001_00']">
			<el-button type='primary' size='mini' class="fx-big-btn" @click="saveClick">保存</el-button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'closeShopTime',
	data () {
		return {
			unOpenDate: [],
			shopId: '',
			timeList: [
				{
					startDate: '',
					endDate: '',
					isShow: false,	// 隐藏删除时间段按钮标记
					errorFlag: false,	// true:stardate交叉, false:stardate不交叉
					errorFlag2: false	// true:endDate发生交叉，false:endDate不交叉
				}
			],
			copyTimeList: [],
			AuthorityList: {
				'01_0001_0001_00': false
			},
			closeShopflag: true,	// 是否启用营业时间标记 false:开启 true:关闭
			newArr: []	// 存放转换为Number的时间段
		}
	},
	created () {
		this.shopId = window.sessionStorage.getItem('storeid')
		this.getAuthority('01_0001_0000_00')
		this.getDateDetail()
	},
	methods: {
		getDateDetail () {
			let params = {
				shopId: this.shopId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/getShopOpenDate`,
				data: params
			}).then(res => {
				if (res.result) {
					if (res.data.unOpenDate !== '') {
						this.unOpenDate = res.data.unOpenDate.split(',')
					}
					this.closeShopflag = res.data.type === 0
					let timeList = res.data.dateList
					if (timeList.length > 0) {
						timeList.forEach(item => {
							item.endDate = item.endDate === '23:59' ? '24:00' : item.endDate
						})
						if (timeList.length === 1) {
							this.timeList = JSON.parse(JSON.stringify(timeList))
							this.timeList.forEach(item => {
								this.$set(item, 'isShow', false)
								this.$set(item, 'errorFlag', false)
								this.$set(item, 'errorFlag2', false)
							})
						} else {
							this.timeList = JSON.parse(JSON.stringify(timeList))
							this.timeList.forEach(item => {
								this.$set(item, 'isShow', true)
								this.$set(item, 'errorFlag', false)
								this.$set(item, 'errorFlag2', false)
							})
						}
					}
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		// 时间转换数字
		date2Number (date1, date2) {
			return date1 && date2 ? [+date1.split(':').join(''), +date2.split(':').join('')] : +date1.split(':').join('')
		},
		// 修改开始时间
		changeStartTime (e, i) {
			if (e.startDate) {
				let date = this.date2Number(e.startDate)
				this.newArr = []
				this.copyTimeList = this.timeList.concat()
				this.copyTimeList.forEach((item, index) => {
					if (item.startDate && item.endDate && i !== index) {
						this.newArr.push(this.date2Number(item.startDate, item.endDate))
					}
				})
				let len = this.copyTimeList.length
				let _BooleanArr = []
				if (len > 1) {
					this.newArr.forEach(item => {
						if ((date > item[0] || date === item[0]) && date < item[1]) {
							e.errorFlag = true
						} else {
							e.errorFlag = false
						}
						_BooleanArr.push(e.errorFlag)
					})
					e.errorFlag = _BooleanArr.some(item => { return item === true })
					// console.log(e)
				}
			} else {
				e.errorFlag = false
			}
		},
		// 修改结束时间
		changeEndTime (e, i) {
			if (e.endDate) {
				let date = this.date2Number(e.endDate)
				this.newArr = []
				this.copyTimeList = this.timeList.concat()
				this.copyTimeList.forEach((item, index) => {
					if (item.startDate && item.endDate && i !== index) {
						this.newArr.push(this.date2Number(item.startDate, item.endDate))
					}
				})
				let len = this.copyTimeList.length
				let _BooleanArr = []
				if (len > 1) {
					this.newArr.forEach(item => {
						if (date > item[0] && (date < item[1] || date === item[1])) {
							e.errorFlag2 = true
						} else {
							e.errorFlag2 = false
						}
						_BooleanArr.push(e.errorFlag2)
					})
					e.errorFlag2 = _BooleanArr.some(item => { return item === true })
				}
			} else {
				e.errorFlag2 = false
			}
		},
		// 添加时间段
		addItem (e) {
			let item = {
				startDate: '',
				endDate: '',
				isShow: true,
				errorFlag: false,
				errorFlag2: false
			}
			this.timeList.push(item)
			this.timeList[0].isShow = true
		},
		// 删除时间段
		deleteItem (item, index) {
			this.timeList.splice(index, 1)
			let len = this.timeList.length
			if (len === 1) {
				this.timeList[0].isShow = false
				this.timeList[0].errorFlag = false
				this.timeList[0].errorFlag2 = false
			} else {
				this.timeList.forEach((e, i) => {
					if (e.errorFlag || e.errorFlag2) {
						this.changeStartTime(e, i)
						this.changeEndTime(e, i)
					}
				})
			}
		},
		// 切换开关
		handleChangeSetting (e) {
			let shopopenflag = e ? 0 : 1
			let params = {
				shopId: this.shopId,
				type: shopopenflag
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/setShopOpenFlag`,
				data: params
			}).then(res => {
				if (res.result) {
					if (!shopopenflag) {
						this.timeList = [
							{
								startDate: '',
								endDate: '',
								isShow: false,
								errorFlag: false,
								errorFlag2: false
							}
						]
					}
					this.$message.success(res.msg)
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		formatDate (arr) {
			let foundIndex = arr.findIndex(item => item === '24:00')
			arr[foundIndex] = '23:59'
			return arr
		},
		saveClick () {
			// console.log(this.timeList)
			let len = this.timeList.length
			for (let i = 0; i < len; i++) {
				if (((!this.timeList[i].startDate && this.timeList[i].endDate) || (this.timeList[i].startDate && !this.timeList[i].endDate)) && len === 1) {
					this.$message.error('时间段不能为空！')
					return false
				}
				if ((!this.timeList[i].startDate || !this.timeList[i].endDate) && len > 1) {
					this.$message.error('时间段不能为空！')
					return false
				}
				if (this.timeList[i].errorFlag || this.timeList[i].errorFlag2) {
					this.$message.error('时间段不能交叉！')
					return false
				}
				if ((this.timeList[i].startDate && this.timeList[i].endDate) && (this.timeList[i].startDate === this.timeList[i].endDate)) {
					this.$message.error('请选择正确时间段！')
					return false
				}
			}
			let unOpenDate = ''
			if (this.unOpenDate && this.unOpenDate.length > 0) {
				unOpenDate = this.unOpenDate.join(',')
			}
			let timeList = this.timeList
			if (timeList.length === 1 && (!timeList[0].startDate && !timeList[0].endDate)) {
				if (!this.unOpenDate || this.unOpenDate.length === 0) {
					this.$message.error('请填写信息！')
					return false
				}
				timeList = null
			}
			let params = {
				unOpenDate: unOpenDate,
				shopId: this.shopId,
				dateList: timeList
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/saveShopOpenDate`,
				data: params
			}).then(res => {
				if (res.result) {
					this.getDateDetail()
					this.$message.success('保存成功！')
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.close-shoptime-body {
	font-size: 12px
	flex-direction: column;
	height: 100%;
	display: flex;
	overflow: hidden
	.row-box{
		text-align: left
		.label {
			display: inline-block
			width: 100px
			text-align: right
		}
	}
	.tips {
		padding: 10px 100px
		color: #999
	}
	.close-shoptime-container {
		display flex
		.setting-change {
			display: flex
			flex-flow: column
			justify-content: start
			align-items: start
			padding-top: 35px
			.label {
				display: inline-block
				width: 100px
				text-align: right
			}
			.tips {
				padding: 10px 100px
				color: #999
			}
		}
	}
	.setting-detail {
		display: flex
		align-items: flex-start
		overflow: hidden
		flex-flow: column
		flex:1
		.detail-box {
			display: flex
			flex-flow: row
			align-items: baseline
			overflow-y: auto;
			padding-right: 45px;
			.label {
				display: inline-block
				width: 100px
				text-align: right
			}
			.all-time-box {
				display: flex;
				flex-flow: column;
				align-items: start;
				.time-item {
					padding: 10px 0
				}
			}
			.el-date-editor.el-input, .el-date-editor.el-input__inner {
				width: 130px
			}
			.delete {
				color: #999
				font-size: 14px
				margin-left: 15px
				cursor: pointer
			}
		}
		.add {
			width: 272px
			min-height: 23px
			border: 1px dashed #999
			margin: 10px 100px
			display: flex
			align-items: center
			justify-content: center
			cursor: pointer
			color: #999
		}
	}
	.button-box {
		hieght:40px;
		width: 100%
		bottom: 20px
		margin-top: 40px
		display: flex
		justify-content: center
		align-items: center
	}
}
</style>
<style lang="stylus">
.el-dialog__body{
    padding:0px 20px 20px 20px
}
.set-flag-switch .el-switch__label {
	position: absolute;
	display: none;
	color: #fff;
}
.input-error .el-input__inner {
	border-color: #F56C6C
}
/*打开时文字位置设置*/
.set-flag-switch .el-switch__label--right {
	z-index: 1
	right: 6px
}
/*关闭时文字位置设置*/
.set-flag-switch .el-switch__label--left {
	z-index: 1
	left: 9px
}
/*显示文字*/
.set-flag-switch .el-switch__label.is-active {
	display: block;
}
.set-flag-switch.el-switch .el-switch__core, .el-switch .el-switch__label {
	width: 40px !important;
}
.el-picker-panel {
	text-align: center !important
}
</style>
